import Model from './Model';
import Collection from './Collection';

/**
 * User model
 *
 * @param {number} id
 * @param {string} name
 * @param {string} email
 * @param {string} password
 * @param {number} access
 */
export class User extends Model {

	static userLevels = [
		{
			value: 0,
			label: 'No access',
		},
		{
			value: 2,
			label: 'Access',
		},
		{
			value: 3,
			label: 'Admin',
		},
		{
			value: 5,
			label: 'Owner',
		},
		{
			value: 7,
			label: 'Manager',
		},
	];

	// Default attributes that define the "empty" state.
	defaults() {
		return {
			id: null,
			realName: '(not set)',
			username: '(not set)',
			email: '(not set)',
			password: '',
			access: null,
			settableRoles: [],
		};
	}

	// Attribute mutations.
	mutations() {
		return {
			id: id => Number(id) || null,
			realName: name => Boolean(name) ? String(name) : '(not set)',
			email: email => Boolean(email) ? String(email) : '(not set)',
			password: String,
			access: Number,
		};
	}

	// Route configuration
	routes() {
		return {
			fetch: '/users/{id}',
			save: '/users',
			invite: '/users/invite',
			returning: '/users/returning',
		};
	}

	options() {
		return {
			patch: true,
			methods: {
				invite: 'POST',
				returning: 'POST',
			},
		};
	}
	
	/**
	 * Method for custom route 'invite' to invite user to project
	 * @param {Number} projectId Project ID to invite to
	 * @param {String} name User name
	 * @param {String} email User email
	 *
	 * @returns {Promise} Result of inviting user
	 */
	invite(projectId, name, email) {
		const method = this.getOption('methods.invite');
		const route = this.getRoute('invite');
		const url = this.getURL(route, this.getRouteParameters());

		return new Promise((resolve, reject) => {
			this.getRequest({
					method,
					url,
					headers: { Authorization: '' },
					data: { projectId, name, email } })
				.send()
				.then(({ response }) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	}

	returning() {
		const method = this.getOption('methods.returning');
		const route = this.getRoute('returning');
		const url = this.getURL(route, this.getRouteParameters());

		return new Promise((resolve, reject) => {
			this.loading = true;
			this.getRequest({ method, url, headers: { Authorization: '' } })
				.send()
				.then(({ response }) => {
					this.assign(response.data);
					resolve();
				})
				.catch((error) => {
					reject(error);
				})
				.finally(() => {
					this.loading = false;
				});
		});
	}

}

/**
 * Users collection
 */
export class Users extends Collection {

	// Model that is contained in this collection.
	model() {
		return User;
	}

	// Route configuration
	routes() {
		return {
			fetch: '/users',
		};
	}

}
